import React from 'react'

import { useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import { IApplicationState } from '@store'
import { selectFilteredIdentityIds } from '@store/brandFans'
import { selectCurrentBrandFansFilter } from '@store/router'
import { Container } from '@tribegroup'
import InfluencerIdentityTopPanelBrandFilters from './BrandFilters'
import InfluencerIdentityTopPanelSort from './Sort'

const BrandFansInfluencerIdentityTopPanel: React.FC = () => {
  const currentFilter = useSelector((state: IApplicationState) =>
    selectCurrentBrandFansFilter(state),
  )
  const identityCount = useSelector(
    (state: IApplicationState) => selectFilteredIdentityIds(state, currentFilter).length,
  )

  return (
    <Container topOuterSpacing={6}>
      <Flex justifyBetween>
        <InfluencerIdentityTopPanelBrandFilters />
        {identityCount > 0 && <InfluencerIdentityTopPanelSort />}
      </Flex>
    </Container>
  )
}

export { BrandFansInfluencerIdentityTopPanel }
export default BrandFansInfluencerIdentityTopPanel
